<script>
import Card from "@/components/molecules/card";
import Divider from "@/components/atoms/divider";
import BadgeStatus from "@/components/molecules/badge-status";
import Icon from "@/components/atoms/icon";
import {
  monCompteAbonnementOverviewProps,
  useMonCompteAbonnementOverview
} from "./mixin";

export default {
  name: "AbonnementOverviewMobile",
  components: {
    Card,
    Divider,
    BadgeStatus,
    Icon
  },
  props: {
    ...monCompteAbonnementOverviewProps()
  },
  setup(props) {
    const { badgeColor, dateFin } = useMonCompteAbonnementOverview(props);
    return { badgeColor, dateFin };
  }
};
</script>

<template>
  <Card
    class="abonnement-overview u-px-md u-py-sm"
    radius="lg"
    elevation="sm"
  >
    <div class="u-flex u-flex-justify-between u-flex-justify-start@md u-flex-align-center u-flex-column@md ">
      <div class="abonnement-overview__information u-flex u-flex-column u-flex-row@md u-flex-justify-between@md u-flex-align-center@md u-full-width@md u-mb-xs@md u-pr-sm u-pr-none@md">
        <p class="abonnement-overview__name u-font-15 u-mb-xs u-mb-none@md">
          <strong>
            {{ abonnement.attributes.libelle }}
          </strong>
        </p>
        <div class="u-font-15">
          {{ abonnement.attributes.prix }}&nbsp;€
        </div>
      </div>
      <Divider
        dotted
        class="u-none u-block@md u-full-width"
      />
      <div class="abonnement-overview__shop u-flex u-flex-align-center u-font-15 u-full-width@md u-mb-sm@md u-pr-sm u-pr-none@md u-pl-sm u-pl-none@md u-mt-xs@md">
        <Icon
          name="shop"
          variant="primary"
          size="sm"
          class="u-mr-xs u-flex-shrink-none"
        />
        {{ abonnement.attributes.magasin_nom }}
      </div>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-none@md"
      />
      <div class="abonnement-overview__status u-flex u-flex-align-center u-full-width@md u-mb-sm@md u-pl-md u-pl-sm@lg u-pl-xxs@md">
        <BadgeStatus
          :status="badgeColor"
          size="xs"
          class="u-font-15"
        >
          <template v-if="abonnement.attributes.en_cours">
            Actif jusqu'au
          </template>
          <template v-else>
            Terminé le
          </template>
          {{ dateFin }}
        </BadgeStatus>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
.abonnement-overview {
}

.abonnement-overview__information {
  width: 41%;

  @include mq(bp(md)) {
    width: 100%;
  }
}

.abonnement-overview__name {
  @include mq(bp(md)) {
    width: 60%;
  }
}

.abonnement-overview__shop {
  width: 30%;

  @include mq(bp(md)) {
    width: 100%;
  }
}

.abonnement-overview__status {
  width: 30%;

  @include mq(bp(md)) {
    width: 100%;
  }
}
</style>
